import React, {useContext} from "react";
import { useTranslation } from "react-i18next";
import Headroom from "react-headroom";
import "./Header.scss";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import LanguageSwitcher from "../languageSwitcher/LanguageSwitcher";
import StyleContext from "../../contexts/StyleContext";
import {
  greeting,
  workExperiences,
  skillsSection,
  achievementSection,
  resumeSection,
  bigProjects,
  statsSection
} from "../../portfolio";

function Header() {
  const { t } = useTranslation();
  const {isDark} = useContext(StyleContext);
  const viewSkills = skillsSection.display;
  const viewExperience = workExperiences.display;
  const viewProjects = bigProjects.display;
  const viewAchievement = achievementSection.display;
  const viewStats = statsSection.display;
  const viewResume = resumeSection.display;

  return (
    <Headroom style={{zIndex: 999}}>
      <header className={isDark ? "dark-menu header" : "header"}>
        <a href="/" className="logo">
          <span className="grey-color">"\(</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">)"</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={isDark ? "navicon navicon-dark" : "navicon"}></span>
        </label>
        <ul className={isDark ? "dark-menu menu" : "menu"}>
          <li>
            <a href="#greeting">{t('header.home')}</a>
          </li>
          {viewExperience && (
            <li>
              <a href="#experience">{t('header.experience')}</a>
            </li>
          )}
          {viewSkills && (
            <li>
              <a href="#skills">{t('header.skills')}</a>
            </li>
          )}
          {viewProjects && (
            <li>
              <a href="#projects">{t('header.projects')}</a>
            </li>
          )}
          {viewAchievement && (
            <li>
              <a href="#achievements">{t('header.achievements')}</a>
            </li>
          )}
          {viewStats && (
            <li>
              <a href="#stats">{t('header.stats')}</a>
            </li>
          )}
          {viewResume && (
            <li>
              <a href="#resume">{t('header.resume')}</a>
            </li>
          )}
          <li>
            <a href="#contact">{t('header.contact')}</a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <ToggleSwitch />
            </a>
          </li>
          <li>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a>
              <LanguageSwitcher />
            </a>
          </li>
        </ul>
      </header>
    </Headroom>
  );
}
export default Header;
